import L from 'leaflet'

import pinOumanger from '../styles/icons/pin_oumanger.png'
import pinAfaire from '../styles/icons/pin_afaire.png'
import pinOudormir from '../styles/icons/pin_oudormir.png'
import pinAvoir from '../styles/icons/pin_avoir.png'
import pinProduit from '../styles/icons/pin_produit.png'
import pinService from '../styles/icons/pin_service.png'
import markerIcon from '../styles/icons/marker-icon.png'

const iconRestaurant = new L.Icon({
  iconUrl: pinOumanger,
  iconRetinaUrl: pinOumanger,
  iconSize: new L.Point(50, 65),
  className: 'leaflet-div-icon'
})

const iconAFaire = new L.Icon({
  iconUrl: pinAfaire,
  iconRetinaUrl: pinAfaire,
  iconSize: new L.Point(50, 65),
  className: 'leaflet-div-icon'
})

const iconHebergement = new L.Icon({
  iconUrl: pinOudormir,
  iconRetinaUrl: pinOudormir,
  iconSize: new L.Point(50, 65),
  className: 'leaflet-div-icon'
})

const iconAVoir = new L.Icon({
  iconUrl: pinAvoir,
  iconRetinaUrl: pinAvoir,
  iconSize: new L.Point(50, 65),
  className: 'leaflet-div-icon'
})

const iconProduit = new L.Icon({
  iconUrl: pinProduit,
  iconRetinaUrl: pinProduit,
  iconSize: new L.Point(50, 65),
  className: 'leaflet-div-icon'
})

const iconService = new L.Icon({
  iconUrl: pinService,
  iconRetinaUrl: pinService,
  iconSize: new L.Point(50, 65),
  className: 'leaflet-div-icon'
})

const iconUserLocation = new L.Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon,
  iconSize: [30, 40],
  iconAnchor: [10, 40]
  // className: 'leaflet-div-icon'
})

export {
  iconRestaurant,
  iconAFaire,
  iconHebergement,
  iconAVoir,
  iconProduit,
  iconService,
  iconUserLocation
}
